import React from 'react';
import * as messages from '@radnuc/messages';
import ReactDOM from 'react-dom';
import RFGPDFLookup from './RFGPDFLookup';
import { t } from 'i18next';
import './i18n';

export interface IsotopeDisplayProps { isotopes: messages.Rad.IsotopeResult[], laneLabel?: string, altIsotopes?: messages.Rad.IsotopeResult[], altLaneLabel?: string, summary: boolean, allThreatsInSummary?:boolean, hideConfidence?: boolean }
export interface IsotopeDisplayState { showPopout: boolean, popoutIsotopeName: string }

export class IsotopeDisplay extends React.Component<IsotopeDisplayProps, IsotopeDisplayState> {
    constructor(props: IsotopeDisplayProps) {
        super(props)
        this.state = {
            showPopout: false,
            popoutIsotopeName: ''
        }
        this.handleRFGClick = this.handleRFGClick.bind(this);
        this.setPopoutOpen = this.setPopoutOpen.bind(this);
    }

    handleRFGClick(event: React.MouseEvent<HTMLElement>, isotopeName: string) {
        event.stopPropagation();
        //console.log('RFG Click');
        this.setPopoutOpen(true);
        this.setState({
            popoutIsotopeName: isotopeName
        });

    }
    setPopoutOpen(open: boolean) {
        this.setState({
            showPopout: open
        });
    }
    getPopout() {
        let focus = false;
        if (!this.state.showPopout) {
            return null;
        }
        focus = true;
        return (
            <PopoutRFGDisplay title='Radiation Field Guide' isotopeName={this.state.popoutIsotopeName} focus={focus} closeWindow={() => this.setPopoutOpen(false)}>
            </PopoutRFGDisplay>
        );

    }
    //Support functions for investigation card generateion
    hyphenated_nuclide_name(underscore_name: string) {
        var output = underscore_name;
        if (underscore_name.includes("_")) {
            var res = underscore_name.split("_");
            var nuclide_symbol = res[0].toLowerCase();
            var nuclide_number = res[1];
            output = nuclide_symbol[0].toUpperCase() + nuclide_symbol.slice(1) +
                "-" + nuclide_number.toLowerCase();
        }
        return output;
    }

    get_isotope_color(isot_class: string) {
        var this_display_category = isot_class.toUpperCase();
        var color = 'olivedrab'; // NORM

        // COLOR DEFINITION OF
        if (this_display_category.match('INDUSTRIAL')) {
            color = 'orange';
        }
        if (this_display_category.match('RDD')) {
            color = 'orange';
        }
        if (this_display_category.match('MEDICAL')) {
            color = '#4f86f7';
        }
        if (this_display_category.match('SNM')) {
            color = 'red';
        }
        if (this_display_category.match('NUCLEAR')) {
            color = 'red';
        }
        if (this_display_category.match('OVERRANGE')) {
            color = 'OrangeRed';
        }
        if (this_display_category.match('HIGH_DOSE')) {
            color = 'OrangeRed';
        }
        return color;
    }

    convert_conf_string(val: number) {
        var conf_string = '';
        if (val < 12) {
            conf_string = t('LOW',{ns:'trans'});
        }
        if ((val >= 12) && (val < 15)) {
            conf_string = t('MEDIUM',{ns:'trans'});
        }
        if (val >= 15) {
            conf_string = t('HIGH',{ns:'trans'});
        }
        return conf_string;
    }

    render() {
        //Detected Isotopes
        let isotopes: any[] = [];
        let isotope_summary: any | null;
        let overrange_flag = false;
        if (this.props.isotopes !== null) {
            this.props.isotopes.forEach((isotope, index) => {
                let display_element;
                if (isotope.name.match('OVERRANGE')) {
                    //GAMMA OVERRANGE
                    overrange_flag = true;
                    let color = "OrangeRed";
                    display_element =
                        <div key={index} style={{ display: 'inline-block' }}>
                            <span style={{ cursor: 'pointer', color: color }}>
                                {t('OVERRANGE',{ns:'trans'})} <br></br>{t('ID UNCERTAIN',{ns:'trans'})}
                            </span>
                        </div>
                } else if (isotope.name.match('HIGH_DOSE')) {
                    //HIGH DOSE
                    let color = "OrangeRed";
                    display_element =
                        <div key={index} style={{ display: 'inline-block' }}>
                            <span style={{ cursor: 'pointer', color: color }}>
                                {t('HIGH DOSE',{ns:'trans'})}
                            </span>
                        </div>
                } else {
                    if(!overrange_flag){
                        let color = this.get_isotope_color(isotope.category);

                        //Display confidence if Mobile system
                        let conf_string;
                        let lane_label_element;
                        if(!this.props.hideConfidence){
                            if (isotope.name !== "UNKNOWN") {
                                conf_string = "\t(" + this.convert_conf_string(isotope.pcs_confidence) + ")";
                            }
                        } else {
                            if (this.props.laneLabel !== undefined && this.props.altLaneLabel !== undefined){
                                const lane_string = ' (Lane '+this.props.laneLabel+')';
                                lane_label_element = <span className ='label-speaking' style={{ color: "gray", fontSize: "0.8em" }}>
                                                    {lane_string}
                                                     </span>
                            }
                        }

                        display_element =
                            <div key={index} style={{ display: 'inline-block' }}>
                                <span className='isot-RFG-link-span' style={{ cursor: 'pointer', color: color }} onClick={(event) => { this.handleRFGClick(event, isotope.name) }}>
                                    {t(this.hyphenated_nuclide_name(isotope.name),{ns:'trans'})}
                                    {conf_string}
                                    {lane_label_element}
                                </span>
                            </div>
                    }
                }
                if(display_element)
                    isotopes.push(display_element);

                if (isotope_summary == null)
                    isotope_summary =
                        <div>
                            {display_element}
                        </div>

            });

            if(this.props.allThreatsInSummary) {
                    isotope_summary =
                        <div>
                            <label className="metric" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>{isotopes}</label>
                        </div>
            }

        }

        //Alternate Attribution case
        if (this.props.altIsotopes !== undefined && this.props.altIsotopes !== null) {
            this.props.altIsotopes.forEach((isotope, index) => {
                let display_element;
                let color = this.get_isotope_color(isotope.category);

                //Display confidence if Mobile system
                let conf_string;
                let lane_label_element;
                if(!this.props.hideConfidence){
                    if (isotope.name !== "UNKNOWN") {
                        conf_string = "\t(" + this.convert_conf_string(isotope.pcs_confidence) + ")";
                    }
                } else {
                    if (this.props.laneLabel !== undefined && this.props.altLaneLabel !== undefined){
                        const lane_string = ' (Lane '+this.props.altLaneLabel+')';
                        lane_label_element = <span className ='label-speaking' style={{ color: "gray", fontSize: "0.8em" }}>
                                            {lane_string}
                                             </span>
                    }
                }
                const alt_label_string = '(Lane )'
                display_element =
                    <div key={index+100} style={{ display: 'inline-block' }}>
                        <span className='isot-RFG-link-span' style={{ cursor: 'pointer', color: color }} onClick={(event) => { this.handleRFGClick(event, isotope.name) }}>
                            {this.hyphenated_nuclide_name(isotope.name)}
                            {conf_string}
                            {lane_label_element}
                        </span>
                    </div>

                if(display_element)
                    isotopes.push(display_element);
            });
        }

        var isotope_display;
        if (this.props.summary) {
            isotope_display =
                <>
                    {this.getPopout()}
                    {isotope_summary}
                </>
        } else {
            isotope_display =
                <>
                    {this.getPopout()}
                    <div className="investigation-row">
                        <div className="isotopes inv-metric-container" style={{ width: '100%' }}>
                            <label className="metric-title">{t('Isotopes',{ns:'trans'})}</label>
                            <label className="metric" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>{isotopes}</label>
                        </div>
                    </div>
                </>
        }

        return (isotope_display)   //for now
    }

}
export default IsotopeDisplay

//******************************************************************************
//Popout window for Radiation Field Guide display

interface PopoutRFGDisplayProps {
    title: string;                          // The title of the popout window
    isotopeName: string;
    focus?: boolean;
    closeWindow: () => void;                // Callback to close the popout
}

interface PopoutRFGDisplayState {
    externalWindow: Window | null;          // The popout window
    containerElement: HTMLElement | null;   // The root element of the popout window
}

export class PopoutRFGDisplay extends React.Component<PopoutRFGDisplayProps, PopoutRFGDisplayState> {
    close_popout_timer:NodeJS.Timeout | null = null;
    constructor(props: PopoutRFGDisplayProps) {
        super(props);
        this.state = {
            externalWindow: null,
            containerElement: null
        };
    }

    // When we create this component, open a new window
    public componentDidMount() {
        const features = 'width=600, height=700, left=300, top=200';
        const pdf_file = RFGPDFLookup(this.props.isotopeName);
        const externalWindow = window.open(pdf_file, '', features);

        let containerElement = null;
        if (externalWindow) {

            externalWindow.document.title = this.props.title;

            // Unload method did not close the external window. This closes the window reliably
            this.close_popout_timer = setInterval(()=> {
                if(externalWindow.closed) {
                    if(this.close_popout_timer){
                        clearInterval(this.close_popout_timer);
                        this.close_popout_timer = null;
                    }
                    this.props.closeWindow();
                    if(this.state.externalWindow)
                        this.state.externalWindow.close();
                }
            }, 1000);
        }

        this.setState({
            externalWindow: externalWindow,
            containerElement: containerElement
        });
    }

    public componentDidUpdate(prevProps: PopoutRFGDisplayProps) {
        if(this.props.focus){
            if(this.state.externalWindow)
            this.state.externalWindow.focus();
        }
    }

    // Make sure the window closes when the component unmounts
    public componentWillUnmount() {
        if(this.close_popout_timer){
            clearInterval(this.close_popout_timer);
            this.close_popout_timer = null;
        }
        if (this.state.externalWindow) {
            this.state.externalWindow.close();
        }
    }

    public render() {
        if (!this.state.containerElement) {
            return null;
        }

        // Render this component's children into the root element of the popout window
        return ReactDOM.createPortal(this.props.children, this.state.containerElement);
    }
}
